interface RecruitmentInterviewHistory {
  scheduled_interview?: Array<{
    interviewer?: { toString(): string } | string;
  }>;
  agents?: Array<{ toString(): string } | string>;
}

/**
 * Returns the agent responsible for the first interview.
 *
 * Older recruitment records may not have an interviewer stored against the
 * scheduled interview, so the first assigned agent is retained as a fallback.
 */
export function getFirstInterviewAgentId(
  recruitment?: RecruitmentInterviewHistory
): string | undefined {
  return (
    recruitment?.scheduled_interview?.[0]?.interviewer?.toString() ||
    recruitment?.agents?.[0]?.toString() ||
    undefined
  );
}
